var map = {
	"./": 463,
	"./development": 1391,
	"./development.js": 1391,
	"./index": 463,
	"./index.js": 463,
	"./preprod": 1392,
	"./preprod.js": 1392,
	"./production": 1372,
	"./production.js": 1372,
	"./staging": 1393,
	"./staging.js": 1393
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3374;